
import { Component, Prop, Vue } from 'vue-property-decorator'
import {Toast} from "vant";
import {register} from "@/apis/login/login";
import i18n from '@/lang';
const TEMPLATE = require('./loginVerify.vtmpl');
interface registerUserInfo {
  email: string,
  password: string,
  username: string,
  school: string,
  type: string,
  code: string,
  stno: string,
}
@Component({
  template: TEMPLATE,
})
export default class LoginVerify extends Vue {
  private userCount = ''
  private code = '';
  private userInfo:registerUserInfo = {
    email: '',
    password: '',
    username: '',
    school: '',
    type: '',
    code: '',
    stno: '',
  };
  loginAndRegist() {
    if (!this.code) {
      Toast(i18n.t('Account.请输入验证码'))
      return
    }
    this.userInfo.code = this.code;
    register(this.userInfo).then(res => {
      window.localStorage.setItem('token', res.token);
      window.dispatchEvent(new CustomEvent('onLoginSucceed'));
      this.$store
        .dispatch('setUserInfo')
        .then(() => {
          // 用router-view的刷新来确保 所有的router-view都可以从store的getter里面拿到UserInfo。
          this.$router.push('/');
        })
        .catch((e) => {
          console.log(e)
          window.localStorage.removeItem('token')
          this.$router.push({
            path:'/login',
          })
        })
    }).catch(e => {
      Toast(e.message as string)
    })
  }
  mounted() {
    this.userInfo = JSON.parse(window.sessionStorage.getItem('registerUserInfoCache') || '') as registerUserInfo;
    console.log(this.userInfo)
    let isMobilePhone = /1\d{10}/.test(this.userInfo.email);
    let isEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.userInfo.email);
    this.$setNavInfo({
      title: isEmail? i18n.t('Account.邮箱验证') as string :isMobilePhone?i18n.t('Account.短信验证') as string: i18n.t('Account.类型错误') as string,
      showNavBar: true,
    })
  }
}
